<template>
  <div id="app">
    <div class="opencc-main">
      <h1>在线繁体字转换工具</h1>
      <div class="row">
        <div class="col-xs-6 col-sm-6 m-b-10">
          <div class="input-group">
            <span class="input-group-addon">输入</span>
            <select class="form-control" id="input-select" size="4" v-model="inputSelect">
                <option v-for="option in langList" v-bind:value="option.name" >{{option.text}}</option>
            </select>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 m-b-10">
          <div class="input-group">
            <span class="input-group-addon">输出</span>
            <select class="form-control" id="output-select" size="4" v-model="outputSelect">
                <option v-for="option in langList" v-bind:value="option.name" v-if="option.name != inputSelect">{{option.text}}</option>
            </select>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 m-b-10">
          <div class="text-center">
            <button class="btn btn-success btn-w-xl m-5" type="button" @click="convert"><i class="mdi mdi-cached"></i> 转换字体</button>
            <button class="btn btn-info btn-w-xl m-5 btnClipboard" type="button" data-clipboard-action="copy" data-clipboard-target="#textClipboard"><i class="mdi mdi-content-copy"></i> 复制结果</button>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6 m-b-10">
          <textarea class="form-control border-info" placeholder="输入要转换的字.." auto-height rows="6" v-model="inputText" ref="intextarea" :style="{'height': height}"></textarea>
          <div class="help-block">在左边输入要转换的字，右边自动输出转换结果..</div>
        </div>
        <div class="col-md-6 m-b-10">
          <textarea class="form-control"  placeholder="转换输出.." auto-height readonly rows="6" id="textClipboard" v-model="outputText" :style="{'height': height}"></textarea>
        </div>
      </div>


      <div class="alert alert-info alert-kepu">
        <p><strong>繁体字科普</strong></p>
        <p>简体中文、香港繁体、澳门繁体、台湾繁体的区别</p>
        <p>其中“简体中文”在大陆使用最多，而香港、澳门使用繁体基本一致区别于台湾繁体;</p>
        <p>例子：以简体“里”字为例（香港 => 裏、澳门 => 裏、台湾 => 裡）</p>
        <p><strong>台湾方言</strong></p>
        <p>台湾方言是在台湾口头表达时使用的一种具有地区特点的语言表达，实际上每个地区都存在方言，如：香港的粤语中英混合</p>
        <p>例子：以简体“自行车”字为例（台湾方言 =>脚踏车、繁体 => 自行車）</p>
        <hr/>
        <p><i class="mdi mdi-24px mdi-spin mdi-star"></i> <strong>本工具优点</strong></p>
        <p>与传统简繁转换工具相比，页面分左右设计，输入输出更直观，而且在左边输入时右边即时转出，省去点击鼠标，可以节省50%操作时间，建议收藏</p>
      </div>
    
    </div>
  </div>
</template>

<script>


// import Vue from 'vue';
import Clipboard from 'clipboard';
import calcTextareaHeight from './assets/calcTextareaHeight.js';
const OpenCC = require('opencc-js');//https://github.com/nk2028/opencc-js


export default {
  name: 'App',
  components: {
    Clipboard
  },
  data:function() {
   
		return {
      height: '150px',
      langList:[
        {name:'cn',text:'简体中文'},
        {name:'hk',text:'港澳繁体'},
        {name:'tw',text:'台湾繁体'},
        {name:'twp',text:'台湾方言'}
      ],
      inputSelect:config.inputSelect || 'cn',
      outputSelect:config.outputSelect ||'hk',
      inputText:'',
      outputText:''
		};
	},
  watch: {
    inputText() {
      this.getHeight();
      this.convert();
    },
    inputSelect(){
      this.convert();
    },
    outputSelect(){
      console.log(3);
      this.convert();
    }
  },
	mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
    // Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });


	},
	methods: {
    getHeight() {
    
      var height = calcTextareaHeight(this.$refs.intextarea, 6, null).height;
      
      this.height  = height < 150 ? 150 : height;
    },
		init:function(){
    
      var clipboard = new Clipboard('.btnClipboard');

			clipboard.on('success', function(e) {
        $common.showNotify('复制成功','success');
				e.clearSelection();
			});
			clipboard.on('error', function(e) {
        $common.showNotify('复制失败，浏览器不支持，请手工复制','warning');
			});

		},
    convert:function(){
      if(this.inputSelect == this.outputSelect){
        if(this.outputSelect=='cn'){
          this.outputSelect = 'hk';
        }else{
          this.outputSelect='cn';
        }
      }

      let converter;
      if(this.inputSelect=='cn' && this.outputSelect=='hk'){
     
        converter = OpenCC.ConverterFactory(
          OpenCC.Locale.from.cn, // Simplified Chinese (Mainland China) => OpenCC standard
          OpenCC.Locale.to.hk,   // OpenCC standard => Traditional Chinese (Taiwan)
          [customDict]           // Traditional Chinese (Taiwan) => custom words
        );
      }else{
         converter = OpenCC.Converter({ from: this.inputSelect, to: this.outputSelect });
      }

      this.outputText = converter(this.inputText);

      // 转香港时，床 不要转为 牀
      if(this.inputSelect=='cn' && this.outputSelect=='hk'){
        if(replaceHK?.length>0){
          for(let i in replaceHK){
            this.outputText = this.outputText.replace(replaceHK[i][0],replaceHK[i][1]);
          }
        }
      
      }



//定制
// const converter = OpenCC.CustomConverter([
//   ['香蕉', 'banana'],
//   ['苹果', 'apple'],
//   ['梨', 'pear'],
// ]);
// console.log(converter('香蕉 苹果 梨')); // output: banana apple pear



    }
    
	}
}
</script>


<style scoped>
.opencc-main h1{
 font-size:22px;
 margin-bottom: 20px;
}
.alert-kepu{
  margin-top:50px;
}
.border-success{
  border:1px solid #15c377;
}
.border-info{
  border:1px solid #48b0f7;
}
</style>
